import React, { useState, useEffect } from "react";
import Navbar from "components/Navbars/AuthNavbar";
import { useLocation } from "react-router-dom";
import Footer from "components/Footers/Footer";
import BlockUiOverlay from "components/Expense/BlockUiOverlay";
import AddThreadMessageLogModal from "./AddThreadMessageLogModal";
import axios from "axios";
import BASE_URL from "../BaseUrl/apiConfig";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import UpdateMessageLogModal from "./UpdateMessageLogModal";
import UpdateThreadMessageLogModal from "./UpdateThreadMessageLogModal";
import Swal from "sweetalert2";

function MessageThreads() {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const userID = userData ? userData.userId : null;
  const userTypeId = userData ? userData.userTypeId : null;
  const location = useLocation();
  const { messageId } = location.state || {};
  const [type, setType] = useState("");
  const [messageID, setMessageID] = useState(messageId || "");
  const [recipientName, setRecipientName] = useState("");
  const [recipientEmailOrLink, setRecipientEmailOrLink] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [messageStatus, setMessageStatus] = useState("");
  const [message, setMessage] = useState("");
  const [description, setDescription] = useState("");
  const [messageLogs, setMessageLogs] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showModal3, setShowModal3] = useState(false);
  const [showModal4, setShowModal4] = useState(false);
  const [selectedMessageLog, setSelectedMessageLog] = useState(null);
  const [threadMessages, setThreadMessages] = useState([]);
  const [threadMessagesByID, setThreadMessagesByID] = useState([]);
  const [statusFilter, setStatusFilter] = useState("");
  const [loading, setLoading] = useState(false); // Loader state
  const history = useHistory();
  const [selectedThreadMessageLog, setSelectedThreadMessageLog] =
    useState(null);

  useEffect(() => {
    if (showModal || showModal2 || showModal3) {
      window.scrollTo(0, 0);
    }
  }, [showModal, showModal2, showModal3]);
  useEffect(() => {
    fetchMessage();
    fetchThreadMessages();
  }, []);
  useEffect(() => {
    if (messageID) {
      fetchThreadMessages();
      fetchMessage();
    }
    // Retrieve messageStatus from local storage and set as the default status filter
    const storedStatus = localStorage.getItem("messageStatus");
    if (storedStatus) {
      setStatusFilter(storedStatus);
    }
  }, [messageID]);

  const fetchThreadMessages = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/Expense/GetThreadMesaageLogByID?messageId=${messageID}`
      );
      if (Array.isArray(response.data)) {
        setThreadMessages(response.data);
        console.log("RMN", response.data);
      } else {
        console.error("API response is not an array:", response.data);
        setThreadMessages([]);
      }
    } catch (error) {
      console.error("Error fetching thread messages:", error);
      setThreadMessages([]);
    }
  };

  useEffect(() => {
    fetchMessageLogByIdforView(messageId);
  }, [messageId]);

  const fetchMessageLogByIdforView = (messageId) => {
    fetch(`${BASE_URL}/api/Expense/GetMesaageLogByID?messageId=${messageId}`)
      .then((response) => response.json())
      .then((data) => {
        setMessageLogs(data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const handleStatusChange = async (e) => {
    const selectedStatus = e.target.value;
    setStatusFilter(selectedStatus);
    setLoading(true);

    try {
      const response = await axios.post(
        `${BASE_URL}/api/Expense/UpdateStatus?MessageID=${messageID}&status=${selectedStatus}`
      );

      if (response.data === "Updated") {
        localStorage.setItem("messageStatus", selectedStatus);
        // Optionally, refresh the message logs to reflect any changes
        fetchThreadMessages();
      }
    } catch (error) {
      console.error("Error updating status:", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchMessage = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/Expense/GetMesaageLogByID?messageId=${messageID}`
      );
      setMessage(response.data); // Set the message data here
      console.log("MsgData", response.data);
    } catch (error) {
      console.error("Error fetching message:", error);
      setMessage(""); // Reset message in case of error
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "type") setType(value);
    if (name === "recipientName") setRecipientName(value);
    if (name === "recipientEmailOrLink") setRecipientEmailOrLink(value);
    if (name === "messageStatus") setMessageStatus(value);
    if (name === "description") setDescription(value);
  };

  const handleDateChange = (date) => {
    setStartDate(date);
  };

  const handleSubmitModal = () => {
    setShowModal(false);
    setSelectedMessageLog(null);
    fetchThreadMessages();
    fetchMessage();
  };

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const handleEditClick = (messageLog) => {
    setSelectedMessageLog(messageLog);
    setShowModal2(true);
  };
  const handleEditThreadClick = (threadMessageID) => {
    const selectedThread = threadMessages.find(
      (log) => log.threadMessageID === threadMessageID
    );
    if (selectedThread) {
      setSelectedThreadMessageLog(selectedThread);
      setShowModal3(true);
    }
  };

  const handleUpdate = (newData) => {
    fetchMessageLogs();
    fetchMessageLogByIdforView();
    fetchMessage();
  };
  const updateData = (newData) => {
    fetchThreadMessages();
  };
  const fetchMessageLogs = () => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    const groupId = userData ? userData.groupId : null;
    const userID = userData ? userData.userId : null;
    const userTypeId = userData ? userData.userTypeId : null;

    fetch(`${BASE_URL}/api/Expense/GetAllMesaageLog?UserID=${groupId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        // Filter records based on UserID or userTypeId
        const filteredData = data.filter((log) =>
          userTypeId === 1 ? true : log.userID === userID
        );
        setMessageLogs(filteredData);
        console.log("Filtered data:", filteredData);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const handleResetForm = () => {
    setSelectedMessageLog(null);
  };
  // Dropdown options
  const statusOptions = ["New", "In-Progress", "Closed"];
  const sortedStatusOptions = statusOptions.filter(
    (status) => status !== statusFilter
  );
  if (statusFilter) {
    sortedStatusOptions.unshift(statusFilter);
  }

  const handleDeleteClick = (threadMessageID) => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    const userID = userData ? userData.userId : null;
    const userTypeId = userData ? userData.userTypeId : null;

    // Fetch the record to be deleted
    const recordToDelete = threadMessages.find(
      (log) => log.threadMessageID === threadMessageID
    );

    if (recordToDelete) {
      // Check if UserID matches or userTypeId is 1
      if (userTypeId === 1 || recordToDelete.userID === userID) {
        Swal.fire({
          title: "Are you sure you want to delete this Thread Message?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        }).then((result) => {
          if (result.isConfirmed) {
            fetch(
              `${BASE_URL}/api/Expense/DeleteThreadMsgLog?ThreadMessageID=${threadMessageID}`,
              {
                method: "POST",
              }
            )
              .then((response) => response.json())
              .then((data) => {
                Swal.fire(
                  "Deleted!",
                  "Your Message Thread has been deleted.",
                  "success"
                );
                fetchThreadMessages(); // Fetch the updated message logs
              })
              .catch((error) => {
                console.error("Error:", error);
              });
          }
        });
      } else {
        Swal.fire({
          title: "Unauthorized",
          text: "You are not authorized to delete this record.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    }
  };
  return (
    <>
      <style>{`
        .modal {
          display: flex;
          justify-content: center;
          align-items: center;
          position: fixed;
          z-index: 1000;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background-color: white;
          padding: 20px;
          border-radius: 8px;
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        }

        .overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.5);
          z-index: 999;
          backdrop-filter: blur(4px);  
        }

        .blur {
          filter: blur(4px);   
          pointer-events: none;  
        }

        .message-thread {
          // padding: 15px;
          padding: 0px;
          margin-bottom: 10px;
          border-bottom: 1px solid #ddd;
          display: flex;
          align-items: flex-start;
        }

        .message-thread .status-circle {
          margin-right: 15px !important;
        } 

        .message-thread .details {
          flex: 1;
          margin-left:10px;
          margin-bottom:10px
        }

        .message-thread .header {
          display: flex;
          justify-content: space-between;
          margin-bottom: 5px;
          font-weight: bold;
        }

        .message-thread .details-row {
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
          font-size: 14px;
        }

        .message-thread .details-row div {
          flex: 1;
          text-align: left;
        }

         .message-thread .message-content {
            margin-top: 10px;
        //   font-size: 16px;
            word-wrap: break-word;
            white-space: pre-wrap;
            text-align: justify;  
         }


        .status-circle, .work-circle {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background-color: #007bff;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          font-weight: bold;
        }
          .dropdown-arrow {
          appearance: none;
          -webkit-appearance: none;
          -moz-appearance: none;
          background: none;
          background-color: green;  
          padding-right: 2rem; /* Space for the arrow */
          position: relative;
        }

        .dropdown-arrow + .fas {
          right: 1.75rem;
          top: 50%;
          position: absolute;
          transform: translateY(-50%);
          pointer-events: none; /* Prevent clicking on the arrow */
          color: white;
        }
        
          .message-content h1,
          .message-content h2,
          .message-content h3,
          .message-content h4,
          .message-content h5,
          .message-content h6 {
            font-size: 1.375rem; 
            font-weight: 400;  
          } 

        .status-circle.new { background-color: #28a745; }
        .status-circle.replied { background-color: #ffc107; }
        .status-circle.pending { background-color: #17a2b8; }
        .status-circle.closed { background-color: #dc3545; }
        
      `}</style>
      <Navbar />

      <div className="cust-div" style={{ minHeight: "550px" }}>
        <BlockUiOverlay visible={false} />
        <div className="container mx-auto p-4">
          <div
            className={`flex items-center justify-between mb-4 ${
              showModal || showModal2 || showModal3 ? "blur" : ""
            }`}
          >
            <h1 className="text-2xl font-bold">Message Threads</h1>
            <div className="flex">
              <button
                className="px-4 py-2 text-white bg-blue-500 rounded-md text-xs md:text-base font-bold uppercase mb-1 shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 custom-newbutton mr-3"
                onClick={() => setShowModal(true)}
              >
                + New Thread Message
              </button>
              <div>
                <button
                  className="px-4 py-2 text-white bg-blue-500 rounded-md text-xs md:text-base font-bold uppercase mb-1 shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 custom-newbackkbutton mr-3"
                  type="button"
                  onClick={() => history.goBack()}
                >
                  <i
                    className="fa fa-arrow-circle-left mr-1"
                    title="Go To All Message logs"
                  ></i>
                  Go Back
                </button>
              </div>
            </div>
          </div>
          <AddThreadMessageLogModal
            showModal={showModal}
            setShowModal={setShowModal}
            type={type}
            recipientName={recipientName}
            recipientEmailOrLink={recipientEmailOrLink}
            startDate={startDate}
            messageStatus={messageStatus}
            message={message}
            description={description}
            handleInputChange={handleInputChange}
            handleDateChange={handleDateChange}
            handleSubmit={handleSubmitModal} // Pass handleSubmitModal to handle modal close
            selectedMessageLog={selectedMessageLog}
            updateData={updateData}
          />
          <UpdateMessageLogModal
            showModal={showModal2}
            setShowModal={setShowModal2}
            selectedMessageLog={selectedMessageLog}
            updateData={handleUpdate}
            resetForm={handleResetForm}
          />
          <UpdateThreadMessageLogModal
            showModal={showModal3}
            setShowModal={setShowModal3}
            selectedMessageLog={selectedThreadMessageLog}
            resetForm={handleResetForm}
            updateData={updateData}
          />

          <div className="container mx-auto p-0">
            {Array.isArray(threadMessages) && threadMessages.length > 0 ? (
              threadMessages.map((log) => (
                <div
                  className={`message-thread ${
                    showModal || showModal2 || showModal3 ? "blur" : ""
                  }`}
                  key={log.threadMessageID}
                  title={`Responded By: ${capitalizeFirstLetter(log.userName)}`}
                >
                  {/* Replace status with the first letter of the username */}
                  <div className="work-circle">
                    {log.userName.charAt(0).toUpperCase()}
                  </div>
                  <div className="details">
                    <div className="header">
                      <div style={{ fontSize: "18px" }}>
                        {capitalizeFirstLetter(log.recipientName)}
                      </div>
                      <div
                        style={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        {(userTypeId === 1 || log.userID === userID) && (
                          <>
                            <img
                              title="Edit"
                              src={require("assets/img/Editicon.png")}
                              alt="Edit"
                              className="mr-2 cursor-pointer"
                              style={{ width: "20px" }}
                              onClick={() =>
                                handleEditThreadClick(log.threadMessageID)
                              }
                            />

                            <img
                              title="Delete"
                              src={require("assets/img/deleteicon.png")}
                              alt="Delete"
                              className="cursor-pointer"
                              style={{ width: "20px" }}
                              onClick={() =>
                                handleDeleteClick(log.threadMessageID)
                              }
                            />
                          </>
                        )}
                      </div>
                    </div>
                    <div className="header">
                      <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                        {log.recipientEmailOrLink}
                      </div>

                      <div>
                        {new Date(log.messageDate).toLocaleString("en-GB", {
                          hour12: false,
                          timeZone: "Asia/Kolkata",
                        })}
                      </div>
                    </div>
                    <div className="header">
                      {/* <div style={{ fontSize: "14px" }}>
                        <strong>UserID: </strong> {log.userID}
                      </div> */}
                    </div>
                    <div className="description">{log.description}</div>
                    <div
                      className="message-content"
                      dangerouslySetInnerHTML={{ __html: log.message }}
                    />
                  </div>
                </div>
              ))
            ) : (
              <div></div>
            )}
          </div>
          {message && (
            <div
              className={`message-thread ${
                showModal || showModal2 || showModal3 ? "blur" : ""
              }`}
              key={message.MessageID}
              title={`Responded By: ${capitalizeFirstLetter(message.userName)}`}
            >
              {/* Replace status with the first letter of the username */}
              <div className="work-circle">
                {message.userName.charAt(0).toUpperCase()}
              </div>
              <div className="details">
                <div className="header">
                  <div style={{ fontSize: "18px" }}>
                    {capitalizeFirstLetter(message.recipientName)}
                  </div>
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <img
                      title="Edit"
                      src={require("assets/img/Editicon.png")}
                      alt="Edit"
                      className="mr-2 cursor-pointer"
                      style={{ width: "20px" }}
                      onClick={() => handleEditClick(message)}
                    />
                  </div>
                </div>
                <div className="header">
                  <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                    {message.recipientEmailOrLink}
                  </div>

                  <div>
                    {new Date(message.messageDate).toLocaleString("en-GB", {
                      hour12: false,
                      timeZone: "Asia/Kolkata",
                    })}
                  </div>
                </div>
                <div className="description">{message.description}</div>
                <div
                  className="message-content"
                  dangerouslySetInnerHTML={{ __html: message.message }}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}

export default MessageThreads;
